module.exports = __webpack_public_path__ + "static/media/3.a3250a0e.png";